// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1rVO_","productName":"Table_productName__3k7Wz"};